import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { ACTIONS } from "../../../../_config";

export function useAppLoader() {
  const dispatch = useDispatch();

  const show = useCallback(() => {
    dispatch({
      type: ACTIONS.LOADER.SET_FP_STATUS,
      payload: true,
    });
  }, [dispatch]);

  const hide = useCallback(() => {
    dispatch({
      type: ACTIONS.LOADER.SET_FP_STATUS,
      payload: false,
    });
  }, [dispatch]);

  return { showLoader: show, hideLoader: hide };
}
